<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.customerOrderAfterMap">
            <div class="item">售后编号：{{form.beforeStr.customerOrderAfterMap.order_num || '-'}}</div>
            <div class="item">处理状态：{{afterStateText(form.beforeStr.customerOrderAfterMap.state)}}</div>
            <div class="item">售后方式：{{afterMethodText(form.beforeStr.customerOrderAfterMap.after_method)}}</div>
            <div class="item">退款金额：{{form.beforeStr.customerOrderAfterMap.refund_money}}</div>
            <div class="item">售后原因：{{form.beforeStr.customerOrderAfterMap.after_reason || '-'}}</div>
            <div class="spec-title">申请商品：</div>
            <div class="item" v-if="form.beforeStr.goodsList && form.beforeStr.goodsList.length > 0">
              <div class="table-wrapper">
                <el-table :data="form.beforeStr.goodsList" border size="small">
                  <el-table-column label="商品名称" align="center">
                    <template slot-scope="{row}">{{row.after_goods_name || row.goods_name || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="规格" prop="spec" align="center">
                    <template slot-scope="{row}">{{row.spec || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="数量" prop="after_goods_count" align="center"></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item" v-else>-</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.customerOrderAfterMap">
            <div class="item">售后编号：{{form.afterStr.customerOrderAfterMap.order_num || '-'}}</div>
            <div class="item">处理状态：{{afterStateText(form.afterStr.customerOrderAfterMap.state)}}</div>
            <div class="item">售后方式：{{afterMethodText(form.afterStr.customerOrderAfterMap.after_method)}}</div>
            <div class="item">退款金额：{{form.afterStr.customerOrderAfterMap.refund_money}}</div>
            <div class="item">售后原因：{{form.afterStr.customerOrderAfterMap.after_reason || '-'}}</div>
            <div class="spec-title">申请商品：</div>
            <div class="item" v-if="form.afterStr.goodsList && form.afterStr.goodsList.length > 0">
              <div class="table-wrapper">
                <el-table :data="form.afterStr.goodsList" border size="small">
                  <el-table-column label="商品名称" align="center">
                    <template slot-scope="{row}">{{row.after_goods_name || row.goods_name || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="规格" prop="spec" align="center">
                    <template slot-scope="{row}">{{row.spec || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="数量" prop="after_goods_count" align="center"></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item" v-else>-</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * 售后单变更日志（REQ-2026-234328 3.4，日志类型 91）
 *
 * 快照是后端 SysDataCompareLogService#getCustomerOrderAfterLogJson 直接 SELECT 出来的裸行，
 * 所以字段名是下划线的、枚举也是原始数字，中文都在本文件里转。
 */
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    afterStateText(value) {
      // 口径以售后列表页的 tab 为准（order/afterorder/list.vue）：
      // -1已取消 / 2待寄回商品 / 3待收货 / 31待处理售后 / 41待大区审核 / 42待尤总审核
      // / 4等待用户确认结果 / 5已完成 / 6终止售后
      //
      // 这里原来用的是 20250217 那版旧口径（1待审核 2已同意 3待收货 4已完成 5已拒绝）：
      // 31/41/42/6/-1 **没有映射**，直接显示成裸数字；
      // 更糟的是 2、4、5 **映射到了错的名字** —— 4 会显示成"已完成"，
      // 而它实际是"等待用户确认结果"。**裸数字只是难看，错名字是会误导人做决定的。**
      // 加状态时这里和售后列表页要一起加。
      const map = {
        '-1': '已取消',
        2: '待寄回商品',
        3: '待收货',
        31: '待处理售后',
        41: '待大区审核',
        42: '待尤总审核',
        4: '等待用户确认结果',
        5: '已完成',
        6: '终止售后'
      }
      return map[value] === undefined ? (value == null ? '-' : value) : map[value]
    },
    afterMethodText(value) {
      const map = { 1: '退货退款', 2: '换货', 3: '仅退款' }
      return map[value] === undefined ? (value == null ? '-' : value) : map[value]
    }
  }
}
</script>

<style lang="scss" scoped>
.spec-title {
  font-weight: 500;
  margin-bottom: 5px;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  .el-table {
    max-width: 95%;
  }
}
</style>
